import * as React from 'react';

import TaskProgressWidget from '../task-progress-widget/TaskProgressWidget';
import ZalandoOutfitsProgressWidget from '../zalando-outfits-progress-widget/ZalandoOutfitsProgressWidget';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

import type {
  ReportingDeliverableTypes
} from 'modules/reporting/types';
import type { CreatorPerformance } from '../../types/CreatorPerformance.type';

interface Props {
  isLoading: boolean,
  zalandoOutfit: CreatorPerformance['summary']['tasksProgress']['zalandoOutfit'] | null,
  availableTaskTypes: Array<ReportingDeliverableTypes>,
  outfitsProgress: CreatorPerformance['summary']['outfitsProgress'] | null
}

const ZalandoOutfitReporting = ({
  isLoading,
  zalandoOutfit,
  availableTaskTypes,
  outfitsProgress
}: Props): JSX.Element => {
  if ((zalandoOutfit === null || outfitsProgress === null) && !isLoading) {
    return (
      <section className="zalando-outfits-reporting__empty-message">
        {__t('collabary_common.errors.no_data_error')}
      </section>
    );
  }

  return (
    <React.Fragment>
      <div className="zalando-outfits-reporting__left">
        <TaskProgressWidget
          tasksProgress={{
            instagramPost: null,
            instagramStory: null,
            tiktokVideo: null,
            zalandoOutfit
          }}
          availableTaskTypes={availableTaskTypes}
          isLoading={isLoading}
        />
      </div>
      <div className="zalando-outfits-reporting__right">
        <ZalandoOutfitsProgressWidget
          isLoading={isLoading}
          count={outfitsProgress?.counts ?? {}}
          tasks={outfitsProgress?.progress ?? null}
        />
      </div>
    </React.Fragment>
  );
};

export default ZalandoOutfitReporting;
